import { useState } from "react";
import { SIZES, chooseSize, currentSize, stepSize, type Size } from "../zoom.ts";
import { ToggleWord } from "./ToggleWord.tsx";

/** Makes the whole page smaller or larger, a step at a time, and says how large it is. */
export function TextSize() {
  const [size, setSize] = useState(currentSize);
  const to = (next: Size) => {
    chooseSize(next);
    setSize(next);
  };
  return (
    <span className="text-size" role="group" aria-label="Text size">
      <span className="field-label">Text</span>
      <ToggleWord
        className="text-size-step"
        aria-label="Smaller"
        disabled={size === SIZES[0]}
        onClick={() => to(stepSize(size, -1))}
      >
        −
      </ToggleWord>
      <ToggleWord
        className="text-size-now figures"
        aria-label={`${size}%: back to the usual size`}
        onClick={() => to(100)}
      >
        {size}%
      </ToggleWord>
      <ToggleWord
        className="text-size-step"
        aria-label="Larger"
        disabled={size === SIZES.at(-1)}
        onClick={() => to(stepSize(size, 1))}
      >
        +
      </ToggleWord>
    </span>
  );
}
